<template>
  <div>
    <br />
    <div v-if="listaHorariosProfissional.length === 0" class="well">
      Nenhum profissional em atendimento hoje.
    </div>
    <div v-else>
      <div class="row">
        <div
          v-for="horario in listaHorariosProfissional"
          :key="horario.nome"
          class="col-xs-12 col-sm-6 col-md-3 col-lg-3"
        >
          <div
            style="height: 140px; overflow: auto"
            class="panel panel-default"
          >
            <div class="panel-heading">{{ horario.nome }}</div>
            <table class="table table-striped table-hover">
              <tbody>
                <tr v-for="hora in horario.horas" :key="hora.horarioInicio">
                  <td>{{ hora.horarioInicio }}</td>
                  <td>{{ hora.horarioTermino }}</td>
                  <td>{{ horaBloqueada(hora, horario) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'HorariosProfissional',
  props: {
    data: {
      type: String,
      required: true,
    },
    unidade: {
      type: String,
      required: true,
    },
    especialidade: {
      type: String,
      required: true,
    },
    horariosProfissional: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    listaHorariosProfissional() {
      return Array.isArray(this.horariosProfissional)
        ? this.horariosProfissional
        : []
    },
  },
  methods: {
    horaBloqueada(hora, horario) {
      const d1 = moment(hora.horarioInicio, 'HH:mm')
      const d2 = moment(hora.horarioTermino, 'HH:mm')

      if (!horario.bloqueios || !horario.bloqueios.length) {
        return ''
      }

      for (const bloqueio of horario.bloqueios) {
        const bloqueio1 = moment(bloqueio.dataInicio).set({
          hour: bloqueio.horarioInicio.split(':')[0],
          minute: bloqueio.horarioInicio.split(':')[1],
        })
        const bloqueio2 = moment(bloqueio.dataFim).set({
          hour: bloqueio.horarioFim.split(':')[0],
          minute: bloqueio.horarioFim.split(':')[1],
        })

        if (d2.isBefore(bloqueio1, 'minute')) {
          return ''
        } else if (d1.isAfter(bloqueio2, 'minute')) {
          return ''
        } else if (
          d2.isBetween(bloqueio1, bloqueio2, 'minute') ||
          d1.isBetween(bloqueio1, bloqueio2, 'minute')
        ) {
          return `Indisponível (${bloqueio.motivo})`
        }
      }
    },
  },
}
</script>
